/**
 * Typed boundary over the untyped `FetchApi` helpers for the Tips & Tricks screen.
 */
import ApiNames from "../constants/ApiNames";
import { apiClient } from "./NetworkService";
import type { ApiResponse, TipType } from "../types/tips";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};

export const getTips = async (token?: string): Promise<ApiResponse<TipType[]>> => {
  const res = await apiClient.get(ApiNames.tipsAll, getHeaders(token));
  return res.data;
};
